import { ICallHistory } from 'clickNgo/models/calls'
import { I2029Form } from 'clickNgo/models/crud/forms'

export const mapCallHistoryFrom2029Form = (data: I2029Form): ICallHistory => ({
  created: data.Created,
  createdBy: data.CreatedBy,
  modified: data.Modified,
  modifiedBy: data.ModifiedBy,
  entryId: data.EntryId,
  appId: data.AppId,
  contactId: data.ContactId,
  partnerId: data.PartnerId,
  orgId: data.OrgId,
  user: data.User,
  line: data.Line,
  sentData: JSON.parse(data.SentData),
  error: data.Error,
  receivedData: data.ReceivedData,
  sentAt: data.SentAt,
  receivedAt: data.ReceivedAt,
  dialerType: data.DialerType,
})
